import React from "react";
import { Navigate, useLocation } from 'react-router';

function GuestGuard(props) {
  const location = useLocation()
  const { search } = location
  if (props.isAuthenticated && props.otpFlag === 1) {
    return <Navigate to={`/create-password?agent_email=${props.email}`} />
  } else if (props.isAuthenticated && props.relationalType === 87) {
    return <Navigate to={`/${search}`} />
  } else if(props.isAuthenticated && props.relationalType !== 87){
    return <Navigate to={`/application-management`} state={location.state} />
  }

  return <>{props.children}</>;
}

export default GuestGuard;
